'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { styled } from '@classify/react-core-components/styles';
import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';
import { ROUTES, getPathName } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';
const Wrapper = styled('aside')(({
  theme: {
    spacing,
    palette,
    radius,
    breakpoints
  }
}) => ({
  borderRadius: radius?.banner || 4,
  border: `solid 1px ${palette.layout.surface.border}`,
  padding: spacing(3),
  background: palette.layout.surface.alternativeBackground,
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(2),
  [breakpoints.up('md')]: {
    padding: spacing(4)
  }
}));
const ButtonWrapper = styled('div')(({
  theme: {
    spacing,
    breakpoints
  }
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: spacing(1),
  [breakpoints.up('sm')]: {
    flexDirection: 'row'
  }
}));
export interface AnonymousLoginBannerProps {
  title: string;
  description: string;
}
const AnonymousLoginBanner = t0 => {
  const $ = _c(23);
  const {
    title,
    description
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.toString() ? `?${searchParams.toString()}` : "";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentPathWithQuery = `${pathname}${t1}`;
  let t2;
  if ($[2] !== currentPathWithQuery) {
    t2 = new URLSearchParams({
      _target_path: currentPathWithQuery,
      context: "courseAccess"
    }).toString();
    $[2] = currentPathWithQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const loginQuery = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getPathName(ROUTES.AUTH.LOGIN);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const loginHref = `${t3}?${loginQuery}`;
  let t4;
  if ($[5] !== title) {
    t4 = <Typography variant="h4" color="brand.secondary">{title}</Typography>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== description) {
    t5 = <Typography variant="subtitle1">{description}</Typography>;
    $[7] = description;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "max-content",
      marginBottom: {
        xs: 1,
        sm: 0
      },
      marginRight: {
        xs: 0,
        sm: 1
      }
    };
    t7 = translate("quizpage.not_logged.login_banner.cta.create_account");
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== loginHref) {
    t8 = <Button href={loginHref} variant="primary" sx={t6}>{t7}</Button>;
    $[11] = loginHref;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = translate("quizpage.not_logged.login_banner.cta.login");
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== loginHref) {
    t10 = <Button href={loginHref} variant="tertiary">{t9}</Button>;
    $[14] = loginHref;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t8) {
    t11 = <ButtonWrapper>{t8}{t10}</ButtonWrapper>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t4 || $[21] !== t5) {
    t12 = <Wrapper>{t4}{t5}{t11}</Wrapper>;
    $[19] = t11;
    $[20] = t4;
    $[21] = t5;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default AnonymousLoginBanner;